'use es6';

import { connect } from 'react-redux';
import AppWideKeyboardShortcutsContainer from 'ContentEditorUI/containers/AppWideKeyboardShortcutsContainer';
import { redoModuleReducerChange, undoModuleReducerChange } from 'ContentEditorUI/redux/actions/undoRedoActions';
import { getIsContentTab } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  undoRedoIsActive: getIsContentTab(state)
});
const mapDispatchToProps = {
  redoModuleReducerChange,
  undoModuleReducerChange
};
const EmailKeyboardShortcutsContainer = props => {
  return props.undoRedoIsActive ? /*#__PURE__*/_jsx(AppWideKeyboardShortcutsContainer, {
    hasUndoRedoAccess: true,
    redoAction: props.redoModuleReducerChange,
    undoAction: props.undoModuleReducerChange
  }) : null;
};
export default connect(mapStateToProps, mapDispatchToProps)(EmailKeyboardShortcutsContainer);